
export default function Footer() {
  const services = [
    'Vidéo Surveillance',
    'Détection Incendie',
    'Contrôle d\'Accès',
    'Extinction Automatique',
    'Système Anti-Intrusion'
  ];

  const quickLinks = [
    { name: 'Accueil', href: '#accueil' },
    { name: 'Services', href: '#services' },
    { name: 'À Propos', href: '#apropos' },
    { name: 'Partenaires', href: '#partenaires' },
    { name: 'Contact', href: '#contact' }
  ];

  return (
    <footer className="bg-gray-900 text-white">
      <div className="container mx-auto px-4 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          {/* Logo et Description */}
          <div className="md:col-span-1">
            <div className="flex items-center mb-4">
              <img 
                src="https://static.readdy.ai/image/686bee9df6fcbede85637f4fe190f1d8/344f11ef8de285bde037cb81bbf2c864.jfif" 
                alt="Cobra Sécurité Logo" 
                className="w-12 h-12 object-contain mr-3"
              />
              <h3 className="text-xl font-bold">
                COBRA SECURITE
              </h3>
            </div>
            <p className="text-gray-400 text-sm leading-relaxed">
              Votre partenaire de confiance pour tous vos besoins en sécurité. Solutions professionnelles et sur mesure.
            </p>
          </div>

          {/* Services */}
          <div>
            <h4 className="text-lg font-semibold mb-4">Nos Services</h4>
            <ul className="space-y-2">
              {services.map((service) => (
                <li key={service}>
                  <a href="#services" className="text-gray-400 hover:text-white text-sm transition-colors cursor-pointer">
                    {service}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Liens Rapides */}
          <div>
            <h4 className="text-lg font-semibold mb-4">Liens Rapides</h4>
            <ul className="space-y-2">
              {quickLinks.map((link) => (
                <li key={link.name}>
                  <a href={link.href} className="text-gray-400 hover:text-white text-sm transition-colors cursor-pointer">
                    {link.name}
                  </a>
                </li>
              ))}
              <li>
                <a href="https://readdy.ai/?origin=logo" className="text-gray-400 hover:text-white text-sm transition-colors cursor-pointer">
                  Made with Readdy
                </a>
              </li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="text-lg font-semibold mb-4">Contact</h4>
            <div className="space-y-3">
              <div className="flex items-center">
                <i className="ri-phone-line text-red-500 mr-3"></i>
                <span className="text-gray-400 text-sm">71 348 109</span>
              </div>
              <div className="flex items-center">
                <i className="ri-mail-line text-red-500 mr-3"></i>
                <span className="text-gray-400 text-sm">cobra@cobrasecurite.com.tn</span>
              </div>
              <div className="flex items-center">
                <i className="ri-map-pin-line text-red-500 mr-3"></i>
                <span className="text-gray-400 text-sm">5, rue Ali Darghouth Imm. Mostakbel 2 ap. B73 - Tunis</span>
              </div>
              <div className="flex items-center">
                <i className="ri-time-line text-red-500 mr-3"></i>
                <span className="text-gray-400 text-sm">Du lundi au samedi</span>
              </div>
            </div>
          </div>
        </div>

        {/* Copyright */}
        <div className="border-t border-gray-800 mt-8 pt-8 text-center">
          <p className="text-gray-400 text-sm">
            © 2024 Cobra Sécurité. Tous droits réservés.
          </p>
        </div>
      </div>
    </footer>
  );
}
